import React from 'react';
import {useDispatch} from 'react-redux'
import {MdAdd, MdRemove} from 'react-icons/md';
import styles from './Products.module.css';
import { Image } from '../../../../../../components';
import { addAmount, subAmount, removeFromBasket } from '../../../../../../../support/store/BasketReducer';
import { measureTypeForm, leadTimeToText } from '../../../../../../../support/services/formatter';

function useProduct(commands){
  const dispatch = useDispatch();

  function addBasketItemAmount(basketAmount, availableStock,  offerId, type) {
  
    if (basketAmount >= availableStock && type !== 'scheduled_delivery') return;
    dispatch(addAmount({ id: offerId}));
  }

  function subBasketItemAmount(basketAmount, offerId) {
    if (basketAmount === 1) {
      return removeItemFromBasket(offerId);
    }

    // setBasketAmount(basketAmount - 1);
    dispatch(subAmount({ id: offerId }));
  }

  function removeItemFromBasket(offerId) {
    if (window.confirm('Você deseja realmente remover da cesta?')) {
      dispatch(removeFromBasket({ id: offerId }));
    }
  }

  return({
    eventHandlers:{
      addBasketItemAmount,
      subBasketItemAmount
    }
  })
}



export default function Product(props) {
  const { sharedStates, remoteStates, commands } = props;
  const {eventHandlers} = useProduct(commands);
  
  const {
    id,
    name,
    imagesPaths,
    measureQuantity,
    measureType,
    value,
    type,
    leadTime,
    availableStock,
    basketAmount
  } = sharedStates;

  return (
    <div className={styles.container}>
      <section className={styles.productInfo}>
        <section className={styles.cardImage}>
          <Image src={imagesPaths[0]} alt="Foto do produto" />
        </section>

        <section className={styles.offerInfo}>
          <div>
            <h3 className={styles.name}>{name}</h3>
            <p className={styles.measure}>
              {Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)}
              {` (${measureQuantity} ${measureTypeForm(measureType, measureQuantity).substring(0, 3)})`}
            </p>
            <p className={styles.available}>
              {type === 'scheduled_delivery'
                ? `${leadTimeToText(leadTime)} de preparo`
                : `${availableStock} disponíveis`}
            </p>
          </div>
        </section>
      </section>

      <section className={styles.summary}>
        <h2 className={styles.itemPrice}>
          {Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(basketAmount * value)}
        </h2>
        <div className={styles.amountInput}>
          {/* <MdRemove className={styles.amountIcon} onClick={()=>eventHandlers.subBasketItemAmount(basketAmount,id)} size={17} color="#888" strokeWidth='0.5'/> */}
          <p className={styles.amount} >{basketAmount}</p>
          {/* <MdAdd className={styles.amountIcon} onClick={()=>eventHandlers.addBasketItemAmount(basketAmount, availableStock, id, type)} size={17} color="#888"  strokeWidth='0.5'/> */}
        </div>
      </section>
    </div>
  );
}
